export enum MessageSourceEnum {
  SFMC_JB = 'SFMC_JB',
  API = 'API',
  TAKO_WEB = 'TAKO_WEB',
  TAKO_BULK = 'TAKO_BULK',
}
